<template>
    <PageLayout :title="$t('user_cabinet')">
        <v-row align="center" justify="center" style="height: 70vh">
            <v-col class="px-0">
                <v-card-text class="registration-card">
                    <form>
                        <v-container fluid>
                            <form dense>
                                <v-col cols="12" md="12" style="padding: 0">
                                    <v-text-field
                                        :label="$t('phone_number')"
                                        outlined
                                        v-model="creditionals.phone"
                                        v-validate="'required'"
                                        :error-messages="errors.collect('phone')"
                                        data-vv-name="phone"
                                        required
                                        v-mask="$t('mask.phone')">
                                    </v-text-field>
                                </v-col>

                                <v-col cols="12" md="12" style="padding: 0" v-if="app_settings.is_password_required">
                                    <v-text-field
                                        :label="$t('password')"
                                        outlined
                                        v-model="creditionals.password"
                                        :type="showPassword ? 'text' : 'password'"
                                        :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                                        @click:append="showPassword = !showPassword"
                                        v-validate="{required: true, min: 6, regex: /^[a-zA-Z0-9$@$!%*?&#^-_.+]+$/}"
                                        :error-messages="errors.collect('password')"
                                        data-vv-name="password"
                                        required
                                        ref="password"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="12" style="padding: 0"  v-if="app_settings.is_password_required">
                                    <router-link to="/forgot-password">
                                        <a>{{$t('forgot_password')}}</a>
                                    </router-link>
                                </v-col>
                                <div class="pt-2">
                                    <div class="login-button auth-button">
                                        <v-btn depressed large class="w100" color="lightgrey" @click="auth()">{{$t('enter')}}</v-btn>
                                    </div>
                                    <div class="login-button">
                                        <v-btn depressed large class="w100" color="primary" @click="toRegister()">{{$t('register')}}</v-btn>
                                    </div>
                                </div>
                            </form>
                        </v-container>
                    </form>
                    <overlay-loader :show="isLoading"></overlay-loader>
                </v-card-text>
            </v-col>
        </v-row>
    </PageLayout>
</template>

<script>
// import { Plugins } from '@capacitor/core';
import settings from "@/environment";
import OverlayLoader from '@/app/shared/components/app-loader/Loader';
import ValidatePhone from '@/app/mobile/registration/shared/components/ValidatePhone';
import PageLayout from "@/app/mobile/ui/PageLayout";

// const { Storage } = Plugins;

export default {
  $_veeValidate: {
    validator: 'new',
  },
  name: 'NewLogin',
  components: {
    OverlayLoader,
    ValidatePhone,
      PageLayout
  },
  data() {
    return {
      showPassword: false,
      validatePhone: false,
      utm_marks: {},
    };
  },
  created() {
    if (this.$route.query.sum) {
      localStorage.sum = parseInt(this.$route.query.sum);
    }
    if (this.$route.query.days) {
      localStorage.days = parseInt(this.$route.query.days);
    }
    if (this.isLoggedIn) {
      this.$router.push({ path: '/panel/offers' });
    }
  },
  async mounted() {
        // const ret = await Storage.get({ key: 'referrer' });
        // console.log(ret.value);
        // if (ret.value != null) {
        //     var utm_marks = {};
        //     var marks = ret.value.replace(/%3D/g, "=").split("%26").forEach((x) =>{
        //         const element = x.split("=");
        //         utm_marks[element[0]] = element[1];
        //     });
        //     this.utm_marks = utm_marks;
        // }
        // const ret = "utm_source%3Dgoogle%26utm_medium%3Dcpc%26utm_term%3Dfgsdfg%26utm_content%3Dxcvbxcvb%26utm_campaign%3Dxcvbxcvb%26anid%3Dadmob";

  },
  computed: {
    app_settings() {
      return this.$store.getters.APP_SETTINGS;
    },
    isLoggedIn() {
      return this.$store.getters.IS_LOGGED_IN;
    },
    isLoading() {
      return this.$store.getters.AUTH_IS_LOADING;
    },
    formValid() {
      return Object.keys(this.fields).every(field => this.fields[field] && this.fields[field].valid);
    },
    creditionals() {
      return this.$store.getters.AUTH_CREDITIONALS;
    },
  },
  methods: {
    auth() {
        this.$validator.validateAll().then((result) => {
            if (result) {
            this.creditionals.phone = this.creditionals.phone.replace(/\D+/g, '');
            this.$store.dispatch('SET_AUTH_CREDITIONALS', this.creditionals);
            this.$store.dispatch('AUTH')
                .then((data) => {
                try {
                    this.$metrika.reachGoal('vhod');
                } catch (error) {
                    console.log(error);
                }
                    this.sendUtms(data.data.id);
                    this.$router.push('/panel/offers');
                })
                .catch(() => {
                    this.$toast.error(this.$t('errors.wrong_auth_params'));
                });
            }
        });
    },
      toRegister() {
          this.$router.push({ path: '/register' });
      },
    sendUtms(profile_id){
        let params = {
            utm_campaign: this.utm_marks.utm_campaign ? this.utm_marks.utm_campaign : '',
            utm_content: this.utm_marks.utm_content ? this.utm_marks.utm_content : '',
            utm_medium: this.utm_marks.utm_medium ? this.utm_marks.utm_medium : '',
            utm_source: this.utm_marks.utm_source ? this.utm_marks.utm_source : '',
            utm_term: this.utm_marks.utm_term ? this.utm_marks.utm_term : '',
            profile_id: profile_id,
        };
        this.$store.dispatch('SEND_UTMS', params);
    },
  },
};
</script>

<style>
    .login__title {
        text-align: center;
    }

    .login-button {
        text-align: center;
        margin-top: 15px;
    }

    .registration-card {
        padding: 40px 40px 0;
    }
    @media (max-width: 960px) {
        .registration-card {
            padding: 0 10px;
        }
    }
</style>
